import React from 'react';
import { RouteObject, Navigate } from 'react-router';

import { Auth0Guard } from '@anyx/common-auth';
import { Restricted, Auth0Permissions } from '@anyx/common-permission';
import { ReportStockValueRoutePath } from '@anyx/common-routing';
import { UnauthorizedMessage } from '@anyx/shared-ui';

const InventoryStockValueListPage = React.lazy(() =>
  import('./pages/list').then((module) => ({ default: module.InventoryStockValueReportPage }))
);

const InventoryStockValueTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.InventoryStockValueTemplate }))
);

export const routes: RouteObject[] = [
  {
    path: 'inventory-stock-value',
    element: (
      <Auth0Guard>
        <Restricted
          permissions={[[Auth0Permissions.CAN_USE_ANALYTICS]]}
          fallback={<UnauthorizedMessage />}
        >
          <InventoryStockValueTemplate />
        </Restricted>
      </Auth0Guard>
    ),
    children: [
      {
        path: 'list',
        element: <InventoryStockValueListPage />,
      },
      {
        index: true,
        element: (
          <Navigate
            to={ReportStockValueRoutePath({ workspaceStoreId: null }).list().path}
            replace={true}
          />
        ),
      },
    ],
  },
];
